export const APP_CONFIG = {
  APP_NAME: "WorkPlanX",
  MUTATION_CHANNEL_NAME: "workplanx-mutations-channel",
  MUTATION_EXPIRY_MS: 10000, //10 seconds
  DEFAULT_TIMEZONE: "Australia/NSW",
};
